<!--
 * @Author: 赵健
 * @Date: 2021-01-19 09:53:09
 * @LastEditTime: 2021-01-28 20:14:42
 * @LastEditors: 赵健
 * @Description: 修改描述
 * @FilePath: \trunk\src\views\merchantCenter\orderManage\info.vue
-->
<template>
  <div v-loading="loading">
    <um-bread-crumb />
    <el-card shadow="never">
      <div
        slot="header"
        class="card-header"
      >
        <span>会员信息</span>
      </div>
      <el-row :gutter="20">
        <el-col :span="6">
          <img
            :src="memberInfo.memberPicUrlList&&memberInfo.memberPicUrlList.length?memberInfo.memberPicUrlList[0]:headImg"
            style="width:150px;height:150px;border-radius:50%"
            alt="会员头像"
          >
        </el-col>
        <el-col :span="6">
          <div class="margin-t-20">
            <span class="um-label">姓名：</span>
            <span class="um-value">{{ memberInfo.memberName || '-' }}</span>
          </div>
          <div class="margin-t-20">
            <span class="um-label">会员等级：</span>
            <span class="um-value">{{ memberInfo.memberLevel || '-' }}</span>
          </div>
          <div class="margin-t-20">
            <span class="um-label">项目：</span>
            <span class="um-value">{{ memberInfo.busProjectName || '-' }}</span>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="margin-t-20">
            <span class="um-label">手机号码：</span>
            <span class="um-value">{{ memberInfo.memberMobile || '-' }}</span>
          </div>
          <div class="margin-t-20">
            <span class="um-label">年龄：</span>
            <span class="um-value">{{ memberInfo.memberAge || '-' }}</span>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="margin-t-20">
            <span class="um-label">性别：</span>
            <span class="um-value">{{ memberInfo.memberGender | sex }}</span>
          </div>
          <div class="margin-t-20">
            <span class="um-label">注册时间：</span>
            <span class="um-value">{{ memberInfo.registrationTime || '-' }}</span>
          </div>
        </el-col>
      </el-row>
    </el-card>
    <el-card shadow="never">
      <div
        slot="header"
        class="card-header"
      >
        <span>订单信息</span>
      </div>
      <el-row :gutter="20">
        <el-col :span="6">
          <img
            :src="orderMasterRecord.orderMasterRecordUrlList&&orderMasterRecord.orderMasterRecordUrlList.length?orderMasterRecord.orderMasterRecordUrlList[0]:noData"
            style="width:230px;height:140px"
            alt="权益图片"
          >
        </el-col>
        <el-col :span="6">
          <div>
            <span class="um-label">订单编号：</span>
            <span class="um-value">{{ orderMasterRecord.orderNumberNo || '-' }}</span>
          </div>
          <div class="margin-t-20">
            <span class="um-label">权益名称：</span>
            <span class="um-value">{{ orderMasterRecord.equityName || '-' }}</span>
          </div>
          <div class="margin-t-20">
            <span class="um-label">权益分类：</span>
            <span class="um-value">{{ orderMasterRecord.categoryName || '-' }}</span>
          </div>
          <div class="margin-t-20">
            <span class="um-label">权益限制：</span>
            <span class="um-value">{{ orderMasterRecord.rightsRestrictions || '-' }}</span>
          </div>
          <div class="margin-t-20">
            <span class="um-label">下单时间：</span>
            <span class="um-value">{{ orderMasterRecord.createTime || '-' }}</span>
          </div>
        </el-col>
        <el-col :span="6">
          <div>
            <span class="um-label">订单状态：</span>
            <span class="um-value">{{ orderMasterRecord.orderStatusCode | orderStatus }}</span>
          </div>
          <div class="margin-t-20">
            <span class="um-label">权益板块：</span>
            <span class="um-value">{{ orderMasterRecord.sectionName || '-' }}</span>
          </div>
          <div class="margin-t-20">
            <span class="um-label">权益性质：</span>
            <span class="um-value">{{ orderMasterRecord.equityTypeName || '-' }}</span>
          </div>
          <div class="margin-t-20">
            <span class="um-label">消耗积分：</span>
            <span class="um-value">{{ orderMasterRecord.pointsConsumption || '-' }}</span>
          </div>
          <div class="margin-t-20">
            <span class="um-label">预约使用时间：</span>
            <span class="um-value">{{ orderMasterRecord.useTime || '-' }}</span>
          </div>
        </el-col>
      </el-row>
    </el-card>
    <el-card
      v-if="consumerInfo&&Object.keys(consumerInfo).length!==0"
      shadow="never"
    >
      <div
        slot="header"
        class="card-header"
      >
        <span>消费信息</span>
      </div>
      <el-row :gutter="20">
        <el-col :span="6">
          <img
            :src="consumerInfo.consumerInfoUrlList&&consumerInfo.consumerInfoUrlList.length?consumerInfo.consumerInfoUrlList[0]:noData"
            style="width:230px;height:140px"
            alt="商家图片"
          >
        </el-col>
        <el-col :span="6">
          <div>
            <span class="um-label">商家名称：</span>
            <span class="um-value">{{ consumerInfo.merchantName || '-' }}</span>
          </div>
          <div class="margin-t-20">
            <span class="um-label">使用时间：</span>
            <span class="um-value">{{ consumerInfo.createTime || '-' }}</span>
          </div>
        </el-col>
        <el-col :span="6">
          <div>
            <span class="um-label">商家地址：</span>
            <span class="um-value">{{ consumerInfo.merchantAddress || '-' }}</span>
          </div>
        </el-col>
      </el-row>
    </el-card>
    <el-card
      v-if="returnInfo&&Object.keys(returnInfo).length!==0"
      shadow="never"
    >
      <div
        slot="header"
        class="card-header"
      >
        <span>退回信息</span>
      </div>
      <el-row :gutter="20">
        <el-col :span="6">
          <img
            :src="returnInfo.returnInfoUrlList&&returnInfo.returnInfoUrlList.length?returnInfo.returnInfoUrlList[0]:noData"
            style="width:230px;height:140px"
            alt="商家图片"
          >
        </el-col>
        <el-col :span="6">
          <div>
            <span class="um-label">商家名称：</span>
            <span class="um-value">{{ returnInfo.merchantName || '-' }}</span>
          </div>
          <div class="margin-t-20">
            <span class="um-label">操作时间：</span>
            <span class="um-value">{{ returnInfo.createTime || '-' }}</span>
          </div>
          <div class="margin-t-20">
            <span class="um-label">退回原因：</span>
            <span class="um-value">{{ returnInfo.returnRemark || '-' }}</span>
          </div>
        </el-col>
        <el-col :span="6">
          <div>
            <span class="um-label">操作人：</span>
            <span class="um-value">{{ returnInfo.createUserName || '-' }}</span>
          </div>
        </el-col>
      </el-row>
    </el-card>
    <div style="margin:20px auto;text-align: center;">
      <el-button
        v-if="confirmFlags==0"
        type="warning"
        @click="showBackWindow"
      >退 回</el-button>
      <el-button
        v-if="confirmFlags==0"
        type="primary"
        @click="showConfirmWindow"
      >确 认</el-button>
      <!-- <el-button
        v-if="writeOffFlags==0"
        type="warning"
        @click="cancel"
      >核 销</el-button> -->
    </div>
    <el-dialog
      :visible.sync="backVisible"
      title="退回订单"
      :show-close="false"
      :append-to-body="true"
      width="500px"
    >
      <el-form
        ref="backForm"
        :model="backForm"
        label-width="120px"
      >
        <el-form-item
          ref="remark"
          label="退回说明:"
          prop="remark"
          :rules="[
            {max:200,min:1, message: '长度在1到200个字符', trigger: 'change' },
          ]"
        >
          <el-input
            v-model="backForm.remark"
            style="width:100%"
            placeholder="请输入退回说明"
            maxlength="200"
            type="textarea"
            :rows="3"
          />
        </el-form-item>
      </el-form>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          type="primary"
          @click="back"
        >退回</el-button>
        <el-button @click="backVisible = false;$refs.backForm.resetFields()">取消</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :visible.sync="confirmVisible"
      title="确认订单"
      :show-close="false"
      :append-to-body="true"
      width="600px"
    >
      <el-form
        ref="confirmForm"
        :model="confirmForm"
        label-width="120px"
      >
        <el-form-item
          ref="time"
          label="预约时间:"
          prop="time"
        >
          <el-date-picker
            v-model="confirmForm.time"
            style="width:100%"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          />
        </el-form-item>
        <el-form-item
          ref="remark"
          label="确认说明:"
          prop="remark"
          :rules="[
            {max:200,min:1, message: '长度在1到200个字符', trigger: 'change' },
          ]"
        >
          <el-input
            v-model="confirmForm.remark"
            style="width:100%"
            placeholder="请输入确认说明"
            maxlength="200"
            type="textarea"
            :rows="3"
          />
        </el-form-item>

      </el-form>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          type="primary"
          @click="confirm"
        >确认</el-button>
        <el-button @click="confirmVisible = false;$refs.confirmForm.resetFields()">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  merchantOrderRecordDetail,
  merchantOrderRecordWriteOff,
  merchantOrderRecordreturn,
  merchantOrderRecordConfirm
} from '@/api/merchantCenter'
import moment from 'moment'
export default {
  name: 'MerchantOrderManageInfo',
  filters: {
    orderStatus(val) {
      let type = ''
      switch (val) {
        case 0:
          type = '待确认'
          break
        case 1:
          type = '待使用'
          break
        case 2:
          type = '已使用'
          break
        case 3:
          type = '已过期'
          break
        case 4:
          type = '已退回'
          break
        default:
          type = '-'
          break
      }
      return type
    },
    sex(val) {
      let type = ''
      switch (val) {
        case '1':
          type = '男'
          break
        case '2':
          type = '女'
          break
        default:
          type = '未知'
          break
      }
      return type
    }
  },
  data() {
    return {
      headImg: require('../../../assets/images/headImg.png'),
      noData: require('../../../assets/images/noData.svg'),
      orderId: null,
      loading: false,
      memberInfo: {},
      orderMasterRecord: {},
      consumerInfo: {},
      returnInfo: {},
      writeOffFlags: 1, // 是否可以核销
      confirmFlags: 1, // 是否可以确认和退回
      backVisible: false,
      backForm: { remark: '' },
      confirmVisible: false,
      confirmForm: { remark: '', time: [] }
    }
  },
  created() {
    this.orderId = this.$route.query.orderId
    if (!this.orderId) {
      return this.$router.go(-1)
    }
    this.getInfo()
  },
  methods: {
    async getInfo() {
      try {
        this.loading = true
        const res = await merchantOrderRecordDetail({ orderId: this.orderId })
        this.memberInfo = res.data.memberInfo
        this.orderMasterRecord = res.data.orderMasterRecord
        this.consumerInfo = res.data.consumerInfo
        this.returnInfo = res.data.returnInfo
        this.writeOffFlags = res.data.writeOffFlags
        this.confirmFlags = res.data.confirmFlags
        this.loading = false
      } catch (e) {
        this.loading = false
      }
    },
    showBackWindow() {
      this.backVisible = true
    },
    async back() {
      try {
        this.loading = true
        await merchantOrderRecordreturn({
          orderIdList: [this.orderId],
          remark: this.backForm.remark
        })
        this.$message.success('退回成功！')
        this.$router.go(-1)
        this.loading = false
      } catch (e) {
        this.loading = false
      }
    },
    showConfirmWindow() {
      this.confirmVisible = true
      this.confirmForm.time = [
        this.orderMasterRecord.useStartTime,
        this.orderMasterRecord.useEndTime
      ]
    },
    async confirm() {
      try {
        this.loading = true
        await merchantOrderRecordConfirm({
          orderIdList: [this.orderId],
          remark: this.confirmForm.remark,
          reservationStartTime: this.confirmForm.time
            ? moment(this.confirmForm.time[0]).format('YYYY-MM-DD HH:mm:ss')
            : null,
          reservationEndTime: this.confirmForm.time
            ? moment(this.confirmForm.time[1]).format('YYYY-MM-DD HH:mm:ss')
            : null
        })
        this.$message.success('确认成功！')
        this.$router.go(-1)
        this.loading = false
      } catch (e) {
        this.loading = false
      }
    },
    async cancel() {
      try {
        this.loading = true
        await merchantOrderRecordWriteOff({ orderIdList: [this.orderId] })
        this.$message.success('核销成功！')
        this.$router.go(-1)
        this.loading = false
      } catch (e) {
        this.loading = false
      }
    }
  }
}
</script>
